module.exports = __webpack_public_path__ + "img/dog4.aa545358.jpg";